import React from 'react';

const DeleteOutline = ({ size = '20', fill = '#CE181E', height = '20' }) => {
  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0827 2.8252L12.916 3.65853H15.8327V5.3252H4.16602V3.65853H7.08268L7.91602 2.8252H12.0827ZM4.99935 17.8252H14.9993V6.15853H4.99935V17.8252ZM6.66602 7.8252H13.3327V16.1585H6.66602V7.8252Z"
        fill={fill}
      />
    </svg>
  );
};

export default DeleteOutline;
